<script>import { t, Verbiage } from "@infinitro/content";
import { CheckIcon, EyeIcon, EyeSlashIcon, IncorrectIcon } from "@infinitro/icons";
import { onMount } from "svelte";
import { stateFormMode, statePassword, statePasswordIncorrect, statePasswordSet } from "../state";
import { FormMode } from "../types";
let mode = FormMode.Login;
stateFormMode.subscribe((value) => {
  mode = value;
});
export let disabled = false;
let element;
let valid = false;
let revealed = false;
let required = true;
let incorrect = false;
let password = void 0;
const onChange = () => {
  valid = element.value.length > 0 && element.checkValidity();
  incorrect = false;
  statePassword.set(valid ? element.value : void 0);
  statePasswordSet.set(valid);
  statePasswordIncorrect.set(false);
};
const onBlur = (event) => {
  if (!incorrect) {
    valid = element.value.length > 0 && element.checkValidity();
    statePassword.set(valid ? element.value : "");
    statePasswordSet.set(valid);
  }
};
const onRevealToggle = (event) => {
  event.preventDefault();
  revealed = !revealed;
  element.type = revealed ? "text" : "password";
  console.log(`revealed: ${revealed} ${element.type}`);
};
statePassword.subscribe((value) => password = value);
onMount(async () => {
  if (element && password) {
    element.value = password ?? "";
  }
});
</script>

<span class="section">
	<div class="input">
		<input
			type="password"
			name="password"
			id="password"
			autocomplete="current-password"
			placeholder={mode === FormMode.Register
				? $t(Verbiage.choose_a_password)
				: $t(Verbiage.password)}
			minlength="8"
			{disabled}
			class={$statePasswordIncorrect ? 'invalid' : ''}
			aria-invalid={$statePasswordIncorrect}
			{required}
			bind:this={element}
			on:change={onChange}
			on:input={onChange}
			on:blur={onBlur}
		/>
		<span class="trailing-icon"
			><button type="button" class="reveal" on:click={onRevealToggle}>
				{#if revealed}
					<EyeSlashIcon />
				{:else}
					<EyeIcon />
				{/if}</button
			>
			<span class="check">
				{#if $statePasswordIncorrect}<IncorrectIcon />{:else if valid}
					<CheckIcon />
				{/if}
			</span>
		</span>
	</div>
</span>

<style>
	.section {
    display: flex;
    align-items: center;
    padding-top: 1rem;
    padding-bottom: 1rem
}
	div.input {
    position: relative;
    width: 100%;
    white-space: nowrap
}
	/*
	div.verify-container {
		@apply relative;
	}
	.verify {
		@apply rounded-lg border border-blue-900 shadow-[var(--shadow-neutral)] uppercase font-bold ml-1 text-sm py-4 px-2 w-24 min-w-fit;
	}
	.disabled {
		@apply opacity-50;
	}
	*/
	.trailing-icon {
    pointer-events: auto;
    position: absolute;
    top: 14px;
    right: 0.5rem;
    display: flex;
    padding-right: 0.5rem
}
	.check {
    position: absolute;
    top: 4px;
    left: -8px
}
	.reveal {
    z-index: 40;
    cursor: pointer
}
	input,
	input:disabled {
    display: block;
    width: 100%;
    border-radius: 0.5rem;
    border-width: 1px;
    border-color: var(--color-neutral-900);
    background-color: transparent;
    padding: 1rem;
    font-size: 0.875rem;
    line-height: 1.25rem;
    --tw-text-opacity: 1;
    color: rgb(255 255 255 / var(--tw-text-opacity))
}
	input:focus {
    display: block;
    width: 100%;
    border-radius: 0.5rem;
    border-width: 1px;
    --tw-border-opacity: 1;
    border-color: rgb(59 130 246 / var(--tw-border-opacity));
    background-color: var(--color-background-100);
    padding: 1rem;
    font-size: 0.875rem;
    line-height: 1.25rem;
    --tw-text-opacity: 1;
    color: rgb(255 255 255 / var(--tw-text-opacity));
    --tw-ring-opacity: 1;
    --tw-ring-color: rgb(59 130 246 / var(--tw-ring-opacity))
}
	input.invalid,
	input.invalid:focus {
    --tw-border-opacity: 1;
    border-color: rgb(239 68 68 / var(--tw-border-opacity));
    --tw-ring-opacity: 1;
    --tw-ring-color: rgb(239 68 68 / var(--tw-ring-opacity))
}
</style>
